import React from 'react';
import PropTypes from 'prop-types';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import { SUNLOCK_STATUS_ACTIVE } from 'common/sunlocks/sunlockConstants';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrTable, { SR_TABLE_THEME_CLEAR } from 'client/components/SrTable';

const TABLE_HEADERS_LIST = ['Status From', 'Status To', 'Date'];

const SrSunlockCommandsLogModal = ({
  onClose,
  address,
  sunlockStatus,
  lastPingDate,
  sunlockSerial,
  sunlockLogs,
}) => {
  const _getSunlockStatusContent = () => {
    if (sunlockStatus === SUNLOCK_STATUS_ACTIVE) {
      return {
        icon: '/images/checkmark-circle-green-no-shadow.svg',
        title: 'Active Sunlock Status',
      };
    }
    return {
      icon: '/images/x-circle-icon-red.svg',
      title: `${sunlockStatus} Sunlock Status`,
    };
  };

  const _getStatusDetail = () => {
    if (!lastPingDate) {
      return `Never pinged. #${sunlockSerial}`;
    }

    if (sunlockStatus === SUNLOCK_STATUS_ACTIVE) {
      return `Last pinged ${lastPingDate} ago. #${sunlockSerial}`;
    }

    return `Disconnected ${lastPingDate} ago. #${sunlockSerial}`;
  };

  const _getTableHeaders = () => {
    return TABLE_HEADERS_LIST.map((header) => ({ content: header }));
  };

  const _getTableRows = () => {
    const logs = sunlockLogs || [];
    return logs.map(({ fromStatus, toStatus, createdDate }) => ({
      cells: [
        { content: fromStatus },
        { content: toStatus },
        { content: momentWithAustinTimezone(createdDate).format('YYYY-MM-DD HH:mm:ss') },
      ],
    }));
  };

  const { icon: statusIcon, title: statusTitle } = _getSunlockStatusContent();

  const statusDetail = _getStatusDetail();
  const tableHeaders = _getTableHeaders();
  const tableRows = _getTableRows();

  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent style={{ width: 553, marginTop: 4 }}>
        <SrBox>
          <SrText
            font="greycliff"
            fontSize="26px"
            weight="800"
            lineHeight="36px"
            letterSpacing="0.5"
          >
            Sunlock Commands Log
          </SrText>
        </SrBox>
        <SrBox marginTop="8px">
          <SrText font="greycliff" fontSize="16px" weight="600" color="grey">
            {address}
          </SrText>
        </SrBox>
        <SrFlex marginTop="8px">
          <SrFlex width="25px" justify="center" paddingTop="4px">
            <SrBox width="20px" height="20px" backgroundImage={`url(${statusIcon})`} />
          </SrFlex>
          <SrBox marginLeft="5px" minWidth="200px">
            <SrText font="greycliff" weight="700">
              {statusTitle}
            </SrText>
            &nbsp;
            <SrText font="greycliff" fontSize="16px" weight="600" color="grey">
              {`(${statusDetail})`}
            </SrText>
          </SrBox>
        </SrFlex>
        <SrBox marginTop="17px" maxHeight="30vh" overflowX="scroll">
          <SrTable theme={SR_TABLE_THEME_CLEAR} headers={tableHeaders} rows={tableRows} sticky />
          {sunlockLogs.length === 0 && (
            <SrFlex justify="center" padding="5px">
              <SrText font="greycliff" fontSize="16px" color="grey">
                No logs found.
              </SrText>
            </SrFlex>
          )}
        </SrBox>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrSunlockCommandsLogModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  sunlockStatus: PropTypes.string.isRequired,
  lastPingDate: PropTypes.string,
  sunlockSerial: PropTypes.string.isRequired,
  sunlockLogs: PropTypes.array.isRequired,
};

export default SrSunlockCommandsLogModal;
